import modelBaseV2 from "../model-base-v2.model";

const SoldToModel = {
  getListSoldToCode: function (searchText, body) {
    return modelBaseV2.post(`/api/soldto/list`, { params: { searchText }, body });
  },
};

export default SoldToModel;